import React from 'react'
import Image from '../../components/IPImage'
import { Link, useNavigate } from 'react-router-dom'
import Translations from '../../translations'
import { translate } from '../../base/localization'
import { DATAGATE_THEME, DEFAULT_THEME, DESPEC_THEME, INDEX_THEME, NETEX_THEME } from '../../base/theme/themeConfig'
import { useAppSelector } from '../../redux/app/hooks'
import { selectedTheme } from '../../redux/slices/theme/themeSlice'
import IPButton from '../../components/IPButton'
import { ProductListSpecialFilterType } from '../ProductList/models/commonModels'
import { IBestSellers } from './commonModels/models'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation, Mousewheel, Keyboard, Pagination, Autoplay } from 'swiper'
import './css/styles.scss'
import IPPriceDisplay from '../../components/IPPriceDisplay'

function HomePageBestSellers(props) {
  const t = translate(Translations)
  const theme = useAppSelector(selectedTheme)
  const navigate: any = useNavigate()

  return (
    <section className='home-page-slider section-back-grey  mobile-resize  py-5 p-l-40 p-r-40  m-t-40 text-left '>
      <div className='row'>
        <div className='col d-flex align-items-center'>
          <Image src='/images/coksatanlarikon-01.svg' alt='' style={{ width: '36px', marginTop: '-5px' }} />
          <h4 className='section-back-grey-title'>Çok Satanlar</h4>
        </div>
        {props.data.length > 4 && (
          <div className='col-6'>
            <IPButton
              className={`${theme.name === NETEX_THEME ? 'netex_buttonColor' : ''}${theme.name === INDEX_THEME ? 'index_buttonColor' : ''
                }${theme.name === DEFAULT_THEME ? 'default_buttonColor' : ''}${theme.name === DESPEC_THEME ? 'despec_buttonColor' : ''
                }${theme.name === DATAGATE_THEME ? 'datagate_buttonColor' : ''}`}
              style={{
                width: 'auto',
                float: 'right',
                backgroundColor: '#fff',
              }}
              onClick={() => navigate(`/products?specialFilter=${ProductListSpecialFilterType.BestSellers}&companyId=${theme.id}`)}
              text='Tümünü Göster'
            />
          </div>
        )}
      </div>
      <div
        className={`seperator m-0 ${theme.name === NETEX_THEME ? 'netex_borderBottom' : ''}${theme.name === INDEX_THEME ? 'index_borderBottom' : ''
          }${theme.name === DEFAULT_THEME ? 'default_borderBottom' : ''}${theme.name === DESPEC_THEME ? 'despec_borderBottom' : ''
          }${theme.name === DATAGATE_THEME ? 'datagate_borderBottom' : ''}`}
      ></div>
      <div className='row m-t-10'>
        {props.data.length > 4 ? (
          <Swiper
            navigation={true}
            keyboard={true}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            observer={true}
            observeParents={true}
            modules={[Navigation, Mousewheel, Keyboard, Pagination, Autoplay]}
            className='mySwiper'
          >
            {[...Array(Math.ceil(props.data.length / 4))].map((_, slideIndex) => (
              <SwiperSlide key={slideIndex} style={{ backgroundColor: 'transparent' }}>
                <div className='row'>
                  {props.data.slice(slideIndex * 4, (slideIndex + 1) * 4).map((item: any) => (
                    <div
                      className={`col-12 col-sm-6 col-md-4 col-lg-3 card-mobile-resize${slideIndex === Math.ceil(props.data.length / 4) - 1 ? ' last-column' : ''
                        }`}
                      key={item.Product.Id}
                      style={{ backgroundColor: '#f5f5f5' }}
                    >
                      <div className='most-popular-products'>
                        <div className='room'>
                          <div className='text-center' style={{ marginBottom: '10px', marginTop: '-10px' }}>
                            <b style={{ fontWeight: '600' }}>{item.CategoryName}</b>
                          </div>
                          <div className='room-image text-center'>
                            <Link to={`/product/detail/${item.Product.Id}?from=bestSellers`}>
                              {item.Product.Image ? (
                                <Image
                                  src={item.Product.Image}
                                  alt={item.Product.Name}
                                  className='popular_product'
                                  style={{ objectFit: 'contain' }}
                                />
                              ) : (
                                <Image
                                  src='/images/products/Resim_yok-01.jpg'
                                  alt=''
                                  style={{ objectFit: 'contain' }}
                                />
                              )}
                            </Link>
                          </div>
                        </div>
                        <div className='product-description'>
                          <Link to={`/product/detail/${item.Product.Id}?from=bestSellers`}>
                            <div className='product-title  text-left'>{item.Product.Name}</div>
                          </Link>
                          {/* {item.Product.Model && (
                            <div className='product-title text-left'>Model: {item.Product.Model}</div>
                          )} */}
                          <div className='product-title text-left'>Ürün Kodu: {item.Product.ProductCode}</div>
                        </div>
                        <hr />

                        <div className='row align-items-center product-bottom-fixed justify-content-between '>
                          <div className='col-5 p-0 '>
                            {item.Product.BrandDetail?.ImageUrl && (
                              <Link to={`/products?brandId=${item.Product.BrandId}`}>
                                <Image
                                  src={item.Product.BrandDetail?.ImageUrl}
                                  alt=''
                                  className='popular_product'
                                  style={{ width: '50px' }}
                                />
                              </Link>
                            )}
                          </div>
                          <div className='col-7 text-right mt-2'>
                            <div style={{ display: 'grid' }}>
                              {item.Product.Stock?.Stock > 0 && <span style={{ fontSize: '16px' }}>Size Özel</span>}
                              <ins>
                                {item.Product.Stock?.Stock > 0 ? (
                                  // item.Product.Prices?.Special?.Price
                                  <IPPriceDisplay
                                    price={item.Product.Prices?.Special?.Price ?? '0,00 $'}
                                    integerFontSize='20px'
                                    fractionalFontSize='14px'
                                  />
                                ) : (
                                  <span style={{ color: 'red' }}>{t('pages.homePage.outOfStock')}</span>
                                )}
                              </ins>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          props.data.map(
            (item: IBestSellers, index) =>
              index < 4 && (
                <div className={`col-12 col-sm-6 col-md-4 col-lg-3 card-mobile-resize`} key={item.Product.Id}>
                  <div className='most-popular-products'>
                    <div className='room'>
                      <div className='text-center'>
                        <b>{item.CategoryName}</b>
                      </div>
                      <div className='room-image text-center'>
                        <Link to={`/product/detail/${item.Product.Id}?from=bestSellers`}>
                          {item.Product.Image ? (
                            <Image
                              src={item.Product.Image}
                              alt={item.Product.Name}
                              className='popular_product'
                              style={{ objectFit: 'contain' }}
                            />
                          ) : (
                            <Image src='/images/products/Resim_yok-01.jpg' alt='' style={{ objectFit: 'contain' }} />
                          )}
                        </Link>
                      </div>
                    </div>

                    <div className='product-description'>
                      <Link to={`/product/detail/${item.Product.Id}?from=bestSellers`}>
                        <div className='product-title  text-left'>{item.Product.Name}</div>
                      </Link>
                      {/* {item.Product.Model && <div className='product-title text-left'>Model: {item.Product.Model}</div>} */}
                      <div className='product-title text-left'>Ürün Kodu: {item.Product.ProductCode}</div>
                    </div>

                    <div className='row align-items-center product-bottom-fixed justify-content-between '>
                      <div className='col-5 p-0 '>
                        {item.Product.BrandDetail?.ImageUrl && (
                          <Link to={`/products?brandId=${item.Product.BrandId}`}>
                            <Image
                              src={item.Product.BrandDetail?.ImageUrl}
                              alt=''
                              className='popular_product'
                              style={{ width: '50px' }}
                            />
                          </Link>
                        )}
                      </div>
                      <div className='col-7 text-right mt-2'>
                        <ins>
                          {item.Product.Stock?.Stock > 0 ? (
                            // item.Product.Prices?.Special?.Price
                            <IPPriceDisplay
                              price={item.Product.Prices?.Special?.Price ?? '0,00 $'}
                              integerFontSize='20px'
                              fractionalFontSize='14px'
                            />
                          ) : (
                            <span style={{ color: 'red' }}>{t('pages.homePage.outOfStock')}</span>
                          )}
                        </ins>
                      </div>
                    </div>
                  </div>
                </div>
              )
          )
        )}
      </div>
    </section>
  )
}

export default HomePageBestSellers
